/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserPagination } from 'model/user';

export interface UsersState {
    status: UserStatus;
    loading: boolean;
    error?: string;
    savedUser?: any;
    users: Array<any>;
    pagination?: UserPagination;
}

export enum UserStatus {
    // eslint-disable-next-line no-unused-vars
    Initial,
    // eslint-disable-next-line no-unused-vars
    Error,
    // eslint-disable-next-line no-unused-vars
    Fetching,
    // eslint-disable-next-line no-unused-vars
    FetchSuccess,
    // eslint-disable-next-line no-unused-vars
    Saving,
    // eslint-disable-next-line no-unused-vars
    SaveSuccess,
    // eslint-disable-next-line no-unused-vars
    Deleting,
    // eslint-disable-next-line no-unused-vars
    DeleteSuccess
}
